import React from 'react';
import { useLocation } from 'react-router-dom';
import { format } from 'date-fns';
import BrandHeader from './components/BrandHeader';
import { useLang } from './LangContext';
import './ThankYouPage.css';

interface BookingState {
  customerName: string;
  customerEmail: string;
  day: string;
  slotStart: string;
  duration: number;
  description?: string;
}

export default function ThankYouPage() {
  const location = useLocation();
  const { t } = useLang();
  const { customerName, customerEmail, day, slotStart, duration, description } =
    (location.state as BookingState) || {};

  if (!customerName || !customerEmail || !day || !slotStart || !duration) {
    console.log("No information received...");
    return <p>No booking information found.</p>;
  }

  return (
    <div className="thank-you-page">
      <div className="thank-you-container">
        <BrandHeader />
        <h2>{t.almostThere}</h2>
        <p>{t.sentConfirmationTo} <strong>{customerEmail}</strong>.</p>
        <p>{t.clickLinkInstructions}</p>
        <div className="appointment-details">
          <h3>{t.appointmentSummary}</h3>
          <div className="detail-item">
            <strong>{t.yourName}</strong>
            <span className="detail-value">{customerName}</span>
          </div>
          <div className="detail-item">
            <strong>{t.yourEmail}</strong>
            <span className="detail-value">{customerEmail}</span>
          </div>
          <div className="detail-item">
            <strong>{t.dateAndTime}</strong>
            <span className="detail-value">
              {format(new Date(slotStart), 'dd.MM.yy HH:mm')}
            </span>
          </div>
          <div className="detail-item">
            <strong>{t.duration}</strong>
            <span className="detail-value">{t.durationValue(duration)}</span>
          </div>
          {description && (
            <div className="detail-item">
              <strong>{t.descriptionLabel}</strong>
              <span className="detail-value">{description}</span>
            </div>
          )}
        </div>
        <p className="close-tab-hint">{t.closeTab}</p>
      </div>
    </div>
  );
}
